import { useEffect } from "react";

import type {
    ConversionRatesCategoryOverviewPopListData,
    ConversionRatesCategoryOverviewPopListParams,
} from "@similarweb/pro-api-client";
import Sentry from "@similarweb/sentry-logger";

import { useApiQuery } from "app/modules/api-client";

export const useConversionRateOverviewPopData = (
    params: ConversionRatesCategoryOverviewPopListParams,
    { enabled }: { enabled: boolean },
) => {
    const query = useApiQuery(
        {
            tag: "WebConversionRates",
            methodName: "conversionRatesCategoryOverviewPopList",
            options: { enabled, placeholderData: undefined },
        },
        params,
    );

    const { isError, error } = query;

    useEffect(() => {
        if (isError) {
            Sentry.errorTracker({
                e: error instanceof Error ? error : new Error("Conversion rate PoP overview request failed"),
                message: "Failed to load conversion rate PoP overview",
                level: "error",
            });
        }
    }, [isError, error]);

    const raw = query.data as Partial<ConversionRatesCategoryOverviewPopListData> | undefined;
    const data: ConversionRatesCategoryOverviewPopListData | undefined =
        raw && raw.totalConvertedVisits && raw.avgConversionRate
            ? (raw as ConversionRatesCategoryOverviewPopListData)
            : undefined;

    return { ...query, data };
};
